module.exports = __webpack_public_path__ + "img/how-to-img03.58f87bee.png";